import { useFirestoreQuery, useFirestoreDocumentData } from "@react-query-firebase/firestore";
import { collection, limit, query, where, doc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { firestore } from "../firebase";
import useFirebaseFunction from "./useFirebaseFunction";
import {useQuery} from "react-query";
export default function useBoardHook(subdomain, enableCallback, queryDisabled) {

    const [data, setData] = useState(null);
    const [open_board, isBoardOpening] = useFirebaseFunction("open_board", "europe-west1");

    const boardQuery = useQuery(["publicboard", subdomain], () => {
        return open_board({subdomain}).then((result) => result.data);
    }, {refetchOnWindowFocus: false, refetchOnReconnect: false, enabled: !!subdomain})

    //const board = useFirestoreQuery(["boards", subdomain], ref, {subscribe: false}, {enabled: !queryDisabled && !boardQuery?.data?.id});
    console.log(`boards/${boardQuery?.data?.id}`,{enabled: !queryDisabled && !!boardQuery?.data?.id});
    const board = useFirestoreDocumentData(["boards", subdomain], doc(collection(firestore, 'boards'), `${boardQuery?.data?.id || "a"}`), {subscribe: false}, {enabled: !!subdomain && !queryDisabled && !!boardQuery?.data?.id})

    //console.log(board, "mm", subdomain, queryDisabled, enableCallback);

    useEffect(() => {
        console.log(board?.data, "data??");
        if (board?.data) {
            setData(
                {
                    ...board?.data,
                    id: boardQuery?.data?.id
                }
            )
        } else {
            if (boardQuery?.data?.id) {
                setData(boardQuery.data)
            }
        }
    }, [board?.data, boardQuery?.data?.id])

    console.log(data,"??");
    return {...board, data, isLoading: board.isLoading || isBoardOpening}

}